import { Component, OnInit, ViewChild } from '@angular/core';
import { StockLocation } from '../../../model/location/stock-location';
import { LocationsControllerRequestService } from '../../../services/api/locations-controller-request.service';
import { PAGE_SIZE_OPTIONS } from '../../../services/page-index-service';
import { SnackService } from '../../../services/snack.service';
import { SubscriptionBasedComponent } from '../../../subscription-helpers/subscription-based.component';
import { StockLocationEditComponent } from './location-edit.component';
import { cloneDeep } from 'lodash';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import {
  ModalService,
  ObservableHandlerPair,
} from '../../../services/modal.service';

@Component({
  selector: 'stock-locations-overview',
  templateUrl: './locations-overview.component.html',
  styleUrls: ['./locations-overview.component.scss'],
})
export class StockLocationsOverviewComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  loadingLocations: boolean;
  locations: StockLocation[];
  totalItems = 0;
  pageSizeOptions = PAGE_SIZE_OPTIONS;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private locationsService: LocationsControllerRequestService,
    private snackService: SnackService,
    private modalService: ModalService
  ) {
    super();
  }

  ngOnInit(): void {
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 30;

    this.addSubscription(this.paginator.page, () => this.fetchLocations());

    this.fetchLocations();
  }

  private fetchLocations(): void {
    this.loadingLocations = true;
    this.locations = [];
    this.locationsService
      .getPage(
        null,
        'rack',
        true,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.locations = res.items;
        this.totalItems = res.totalItems;
      })
      .catch(() => {
        this.snackService.showError(
          'Ophalen locaties mislukt. Herlaad de pagina'
        );
      })
      .finally(() => {
        this.loadingLocations = false;
      });
  }

  addLocation(): void {
    this.openLocationEditModal(new StockLocation(), () => {
      this.fetchLocations();
    });
  }

  private openLocationEditModal(
    location: StockLocation,
    successHandler: (result: StockLocation) => void
  ): void {
    this.modalService.openComponentInModal(
      StockLocationEditComponent,
      [{ key: 'location', value: location }],
      new ObservableHandlerPair(
        (modalRef) => modalRef.componentInstance.saveSuccessEvent,
        successHandler
      )
    );
  }

  editLocation(location: StockLocation, i: number): void {
    const locationCopy = cloneDeep(location);
    this.openLocationEditModal(locationCopy, (result) => {
      this.locations[i] = result;
    });
  }
}
